module.exports = function() {
  return new Worker("/" + "unzip_imgs.worker.9d64adae963495095efe.js");
};